import { PricingPlanInterface as PricingPlanProto } from '@vendasta/billing';
import { BillingStrategy, billingStrategyFromAPI } from './billing-strategy';

export interface PricingPlan {
  id: string;
  name: string;
  subscriptionName?: string;
  defaultStrategy: BillingStrategy;
}

export enum Distribution {
  Retail = 'Retail',
  Wholesale = 'Wholesale',
}

export function pricingPlanFromAPI(proto: PricingPlanProto): PricingPlan {
  return {
    id: proto.id || '',
    name: proto.name || '',
    defaultStrategy: billingStrategyFromAPI(proto.defaultBillingStrategy),
  };
}
